var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16,0C 7.164,0,0,7.164,0,16s 7.164,16, 16,16s 16-7.164, 16-16C 32,7.162, 24.836,0, 16,0z M 26,25.278 C 26,25.676, 25.676,26, 25.278,26L 6.722,26 C 6.324,26, 6,25.676, 6,25.278L 6,6.722 C 6,6.324, 6.324,6, 6.722,6l 18.556,0 C 25.676,6, 26,6.324, 26,6.722 L 26,25.278 zM 12,16A4,4 1080 1 0 20,16A4,4 1080 1 0 12,16zM 20,8L 24,8L 24,12L 20,12zM 21.95,16c0,3.282-2.67,5.95-5.95,5.95S 10.050,19.282, 10.050,16c0-0.426, 0.050-0.598, 0.134-1L 8,15 L 8,24 l 16,0 L 24,15 l-2.184,0 C 21.902,15.402, 21.95,15.574, 21.95,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ab618a9c96ffa1c0cc9957b58398b5a4.svg";
export { ForwardRef as ReactComponent };